/* tslint:disable */
/* eslint-disable */
/**
 * Survey API
 * API for managing Surveys and Questions.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface QuestionOrderDto
 */
export interface QuestionOrderDto {
    /**
     * Question ID
     * @type {string}
     * @memberof QuestionOrderDto
     */
    id: string;
    /**
     * New display order
     * @type {number}
     * @memberof QuestionOrderDto
     */
    displayOrder: number;
}

/**
 * Check if a given object implements the QuestionOrderDto interface.
 */
export function instanceOfQuestionOrderDto(value: object): value is QuestionOrderDto {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('displayOrder' in value) || value['displayOrder'] === undefined) return false;
    return true;
}

export function QuestionOrderDtoFromJSON(json: any): QuestionOrderDto {
    return QuestionOrderDtoFromJSONTyped(json, false);
}

export function QuestionOrderDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): QuestionOrderDto {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'displayOrder': json['displayOrder'],
    };
}

export function QuestionOrderDtoToJSON(json: any): QuestionOrderDto {
    return QuestionOrderDtoToJSONTyped(json, false);
}

export function QuestionOrderDtoToJSONTyped(value?: QuestionOrderDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'displayOrder': value['displayOrder'],
    };
}

